import { CModalBody } from "@coreui/react";
import { useDispatch } from "react-redux";
import { useSteps } from "react-step-builder";
import { useUser } from "reactfire";
import { ButtonBasic } from "src/components";
import { useUpdateDatabase } from "src/hooks";
import { setAlertWithTimeout } from "src/store/operations";

const SelfAssessment = ({ onClose }) => {
  const { updateDocument } = useUpdateDatabase();
  // const { showToast } = useToasts();
  const { data: user } = useUser();
  const dispatch = useDispatch();

  const { jump } = useSteps();

  const switchToValidation = async () => {
    try {
      await updateDocument(["esg-survey", user?.uid || "none"], {
        track: "validation",
      });
      // showToast("Track switched to verification", "success");
      dispatch(
        setAlertWithTimeout({
          type: "success",
          text: "Track switched to verification",
        })
      );
      console.log("Track switched to verification");
      onClose();
      jump(0);
    } catch (error) {
      // showToast("Error switching track", "error");
      dispatch(
        setAlertWithTimeout({
          type: "error",
          text: "Error switching track",
        })
      );
      console.log("error", error);
    }
  };

  return (
    <>
      <CModalBody>
        <p className="text-left">
          Congratulations - you've made it to your self-assessment result.
        </p>
        <p>
          Now you can start looking at your next actions to see how to improve
          you scores. Come back and re-assess whenever you're ready!
        </p>
        <p>
          If you're ready for Verification Track - to have you score validated
          and ready for disclosure, click the button below to switch tracks and
          start adding evidence today.
        </p>
        <div className="d-flex justify-content-center w-100">
          <ButtonBasic
            size="lg"
            bgcolor="green"
            hovercolor="darkgreen"
            className="mx-auto"
            onClick={switchToValidation}
            active
            tabIndex={-1}
          >
            Verification
          </ButtonBasic>
        </div>
      </CModalBody>
    </>
  );
};

export default SelfAssessment;
